module.exports = __webpack_public_path__ + "assets/7bfc063946092c65bb39c7dbd048ca07.png";